<template>
  <div>
    <ParagraphBody>
      {{ defaultDeviceGroups }}
    </ParagraphBody>
  </div>
</template>

<script>
import { ParagraphBody } from '@jumpcloud/ui-components';
import { isEmpty } from 'lodash';
import { mapActions, mapState } from 'vuex';
import DefaultDeviceGroupMixin from 'client/groups/System/mixins/DefaultDeviceGroupMixin';

const mdmSettingsModel = 'MdmSettingsModel';

export default {
  name: 'DefaultDeviceGroup',

  components: {
    ParagraphBody,
  },

  mixins: [
    DefaultDeviceGroupMixin,
  ],

  props: {
    item: {
      default: () => ({}),
      type: Object,
    },
  },

  computed: {
    ...mapState(mdmSettingsModel, {
      mdmSettings: 'item',
    }),

    defaultDeviceGroups() {
      const groupId = this.item.id;

      return this.getGroupTypeArray(groupId).map((groupType) => groupType.name).join(', ');
    },
  },

  async mounted() {
    if (isEmpty(this.mdmSettings.mdmDevices)) {
      await this.fetchMdmSettings();
    }
  },

  methods: {
    ...mapActions(mdmSettingsModel, [
      'fetchMdmSettings',
    ]),
  },
};
</script>
